import { create } from "zustand";

// Stato del dialog "Versioni" (easter egg): si apre con 5 tap sul logo (in AppSidebar)
// ed è renderizzato da VersionsDialog (montato nel Layout).
interface VersionsState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useVersionsStore = create<VersionsState>((set) => ({
  open: false,
  setOpen: (open) => set({ open })
}));
